import React from 'react'
import injectSheet from 'react-jss'
import styles from './tablet-portrait-placeholder.styles'
import classNames from 'classnames'
import RotateIcon from './rotate-icon'

const TabletPortraitPlaceholder = ({ classes, className }) => (
  <div className={classNames(classes.container, className)}>
    <div className={classes.box} />
    <p className={classes.title}>Rotate me please</p>
    <p className={classes.desc}>
      This tool is best viewed in landscape mode.<br />Please rotate your
      device.
    </p>
    <RotateIcon />
  </div>
)

export default injectSheet(styles)(TabletPortraitPlaceholder)
